import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';
import Chip from '@mui/material/Chip';
import makeStyles from '@mui/styles/makeStyles';
import { ResourceFilter } from '@monorepo/shared/src/providers/ResourcesProvider/types';

type Props = {
  tag: ResourceFilter;
  onDelete: (tag: ResourceFilter) => void;
};

const ResourceFiltersTag: React.FC<Props> = ({ tag, onDelete }) => {
  const classes = useStyles();

  return (
    <Chip
      tabIndex={-1}
      className={classes.chip}
      component="a"
      label={tag.value}
      onDelete={() => onDelete(tag)}
      deleteIcon={
        <IconButton
          onClick={() => onDelete(tag)}
          aria-label="delete"
          size="small"
          className={classes.deleteButton}
        >
          <FontAwesomeIcon className={classes.deleteIcon} icon={faTimes} />
        </IconButton>
      }
    />
  );
};

const useStyles = makeStyles((theme: any) => ({
  chip: {
    backgroundColor: '#000000',
    color: '#FFFFFF',
    fontWeight: theme.typography.fontWeightRegular,
    height: theme.spacing(6),
    marginTop: '10px',
    '&:hover, &:focus': {
      backgroundColor: '#000000',
      color: '#FFFFFF',
      textDecoration: 'none',
    },
    '&:active': {
      backgroundColor: '#000000',
      boxShadow: theme.shadows[1],
      textDecoration: 'none',
    },
    textDecoration: 'none',
  },
  deleteButton: {
    '&:focus': {
      outline: '#248AFF auto 1px',
    },
  },
  deleteIcon: {
    marginLeft: '5px',
    marginRight: '5px',
    height: '0.8rem',
    color: '#FFFFFF',
  },
}));

export default ResourceFiltersTag;
